import { Plan } from "../api/entities/Plan";
import { Addon, AddonBillingType } from "../api/entities/Addon";
import { Product, ProductDetails } from "../api/entities/Product";
import { GetAddonPrice, GetDiscountPrice } from "./ProductUtils";
import { ProductGroup } from "api/entities/ProductGroup";

export const GetProductDetails = (
  product?: Product,
  productGroup?: ProductGroup,
) => {
  const productDetails: ProductDetails | undefined =
    product && productGroup
      ? {
          ...product,
          pricePerMonth: product.pricePerMonth ?? productGroup.pricePerMonth,
          netCommissionableRevenue:
            product.netCommissionableRevenue ??
            productGroup.netCommissionableRevenue,
          setupFee: product.setupFee ?? productGroup.setupFee,
        }
      : undefined;

  return productDetails;
};

export const PlanGetTotalRecurringPrice = (plan: Plan) => {
  let totalMonthly = 0;
  plan.addonDetailsList.forEach((addon) => {
    if (addon.addonBillingType === AddonBillingType.ParentRecurring) {
      totalMonthly += addon.price;
    }
  });

  if (plan.schedule.totalIntervals > 1) {
    totalMonthly += plan.productDetails.pricePerMonth;
  }
  return totalMonthly;
};

export const GetTotalOneTimePrice = (
  product: ProductDetails | undefined,
  addons: Addon[],
  discount: number,
  productGroupId?: string,
) => {
  let totalOneTime = GetDiscountPrice(product?.pricePerMonth ?? 0, discount);
  addons.forEach((addon) => {
    if (addon.addonBillingType === AddonBillingType.OneTime) {
      totalOneTime += GetAddonPrice(addon, productGroupId);
    }
  });
  return totalOneTime;
};

export const PlansGetTotalRecurringPrice = (plans: Plan[]) => {
  let totalMonthly = 0;
  plans.forEach((plan) => {
    totalMonthly +=
      planIsActive(plan) && plan.schedule.totalIntervals > 1
        ? PlanGetTotalRecurringPrice(plan)
        : 0;
  });
  return totalMonthly;
};

export const planIsActive = (plan: Plan) => {
  return plan.status === "Active" || plan.status === "Ending";
};
